import dayjs from 'dayjs'

import { API_DATE_FORMAT_HOUR_MINUTE_SECOND } from './model'

export const isDateBefore = (
  currentDate: Date,
  targetDate: Date,
  options?: dayjs.OpUnitType,
): boolean => {
  return dayjs(currentDate).isBefore(dayjs(targetDate), options)
}

export const displayDate = (
  date: string | Date | undefined,
  dateFormat = API_DATE_FORMAT_HOUR_MINUTE_SECOND,
) => {
  if (!date) return ''

  try {
    if (date) {
      const d = dayjs(date)
      if (d.isValid()) {
        return d.format(dateFormat)
      }
    }
  } catch (error) {
    console.error(error)
    return '-'
  }

  return '-'
}
